import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormGroup, Label } from 'reactstrap';

import { dataContractApi } from '../../../../helpers/api/dataContractApi';
import { ProtectionTypeText } from '../../../../helpers/enums/protectionTypeEnum';
import RequiredStarLabel from '../../../common/requiredStarLabel';
import EntitySelect from '../../../entitySelect/EntitySelect';
import FormGroupNote from '../../FormGroupNote';

export default function ProtectionTypeSelect({
  isRequired = false,
  isDisabled
}) {
  const { t } = useTranslation();

  const {
    control,
    formState: { errors }
  } = useFormContext();
  return (
    <FormGroup>
      <Label htmlFor="protectionType">
        {t('Protection Type')} {isRequired && <RequiredStarLabel />}
      </Label>
      <Controller
        name="protectionType"
        control={control}
        render={({ field }) => (
          <EntitySelect
            name="protectionType"
            displayName={t('Protection Type')}
            fieldValue={field.value}
            onChange={field.onChange}
            placeholder="Not specified"
            fetchDataFunction={() => {
              return dataContractApi.getDataContractsByContractType(
                'product-protection-types'
              );
            }}
            isFetchDataEnum
            enumToText={ProtectionTypeText}
            isDisabled={isDisabled}
          />
        )}
      />
      {errors.protectionType && (
        <FormGroupNote type="warning">
          {errors.protectionType.message}
        </FormGroupNote>
      )}
    </FormGroup>
  );
}
